export default __webpack_public_path__ + "static/media/img13.48d259ab.png";